import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";

import useThemes from "../../hooks/useThemes";
import useConfigs from "../../hooks/useConfigs";

const SaberMas = ({ label, onClick, type }) => {
  const { colorSecundario } = useThemes();
  const { fontSizeMultiplier } = useConfigs();

  return (
    <Button
      fontsizemultiplier={fontSizeMultiplier}
      color={colorSecundario}
      onClick={onClick}
      type={type}
    >
      <p>{label}</p>
      <FontAwesomeIcon
        icon={faArrowRightLong}
        color={colorSecundario}
        size="lg"
      />
    </Button>
  );
};

export default SaberMas;

SaberMas.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
};

SaberMas.defaultProps = {
  type: "button",
  onClick: () => {},
};

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 20%;
  min-height: 4rem;
  padding: 0.5rem 2.5rem;
  margin-bottom: 2.5rem;
  border: 2px solid ${(props) => props.color};
  border-radius: 2rem;
  background-color: transparent;

  P {
    font-size: ${(props) => 15 * props.fontsizemultiplier};
    font-weight: 700;
    margin: auto 2rem auto 0;
    color: ${(props) => props.color};
  }

  @media (max-width: 1023px) {
    min-width: 40%;
  }
`;
